import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class ServiceRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	getServices(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getServicesHistory(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/history', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getPartnerServices(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/partners', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	sendPartnerContactRequest(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/partners/' + params.businessServiceId + '/contact', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMentalHealthServiceStatus(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/mental/health/status', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMentalHealthServiceAvailability(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/mental/health/availability', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getServiceById(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/' + params.id + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getServiceByUserId(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/byUser/' + params.userId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getServiceFields(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/fields', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBusinessSignupOptions(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/signUp/options', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	postSignUpOne(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/signUp/step1', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	postSignUpTwo(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/signUp/step2', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	postSignUpThree(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/signUp/step3', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateBasicServiceData(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/service/basic', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateServicePricing(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/basic', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createFakeBooking(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/mental/health/concierge/out/of/hours', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getAvailableBookingSchedule(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.businessServiceId + '/times/starting/' + params.startDate + '/ending/' + params.endDate + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createRequest(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/request', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingRequests(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/request/pending', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	respondBookingRequest(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/request/respond?requestId=' + params.requestId, null, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	acceptInstantBookingRequest(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/instant/request/' + params.bookingId + '/accept', null, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInstantBookingRequests(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/instant/request/pending', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInstantAvailabilityStatus(successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/instant/availability/status', {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInstantBookingStatus(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/instant/request/' + params.bookingId + '/status', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingReservationDetails(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.reservationId + '/reservation', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateReservedBooking(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/reservation/update', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateOfficeAddress(params?: any, successCallback?: any, errorCallback?: any) {
		const query = new URLSearchParams({bookingId: params.bookingId, address: params.address}).toString();

		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/address/update?' + query, {}, {
			withCredentials: true
		});

		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}


	setInstantBookingStatus(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/instant/request/' + params.bookingId + '/' + params.status + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	setInstantBookingAvailabilityStatus(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/service/instant/availability/' + params.status + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createInstantBookingRequest(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/instant/request', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createUnpaidInstantBookingRequest(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/instant/request/unpaid', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createUnpaidInstantBookingRequestWithPaymentMethods(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/instant/request/unpaidWithPaymentMethods', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createBooking(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	checkDiscount(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/check/discount', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateBookingConsentsAndGetBankLinks(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/payWithBank', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	confirmBooking(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	confirmBookingForBU(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/confirm', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	declineBookingForBU(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/decline', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	declineAllBookings(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/decline/all', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookings(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getPharmacyRedirectLink(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/access/token', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingDetails(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.bookingId + '/details', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingWithRequestDetails(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.bookingId + '/withRequestDetails', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateSchedule(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/schedule/update', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	timeslotDeadline(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/schedule/time/slot/deadline', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	excludeScheduleDate(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/schedule/exclude/' + params.excludeDate + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	includeScheduleDate(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/schedule/exclude/' + params.excludeDate + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	removeReservedTimeSlot(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/schedule/removeReservedTimeSlot/' + params.bookingId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	activeBookings(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/active/all', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	startChatBot(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/chat/bot/' + params.serviceUserId + '/start', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	bookingsCount(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/active/count', {
			params: params,
			withCredentials: true,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSchedule(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/schedule/starting/' + params.startDate + '/ending/' + params.endDate + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getCCList(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/credit/card/list', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBalance(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/wallet', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	setPrimary(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/credit/card/' + params.cardId + '/asBusinessCard', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	setPrimaryRegular(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/credit/card/' + params.cardId + '/primary', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deleteCreditCard(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/credit/card/' + params.cardId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	addCreditCard(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/credit/card', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	addFunds(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/wallet/funds/add', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getTransactions(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/transaction', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInvoices(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/invoice', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getTherapyFundWallets(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/therapy/fund/wallet', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deactivateTherapyFundWallet(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/therapy/fund/wallet/' + params.walletId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	addTherapyFundWallet(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/therapy/fund/wallet', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getServiceOwnerTherapyFundSettings(successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/therapy/fund/settings', {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	unSubscribe(params?, data?, successCallback?, errorCallback?) {


		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/service/' + params.id + '/unsubscribe', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	subscribe(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/service/' + params.id + '/subscribe', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	recommendToEmployerRequest(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/recommend/to/employer/request/' + params.email + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSubscriptionDept(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/' + params.id + '/subscription/debt', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getCallEndpointForBooking(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.bookingId + '/callInfo', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getCallEndpointForConsultant(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.userId + '/callInfo/consultant', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getCallEndpointForTestCall(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/testCallInfo', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	reportCallFailure(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/call/failure', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getAppointmentNotes(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.bookingId + '/notes', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	saveAppointmentNotes(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/notes', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitNotesToTherapyFund(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/therapy/fund/submit/notes', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	sendQuestionnaire(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/booking/send/questionnaire', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getClientToken(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/purchase/clientToken', {
			params: params,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSupportedBanklinks(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/' + params.bookingId + '/banklinks', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingOffer(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/booking/offer/' + params.bookingOfferId, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBookingOfferSupportedBanklinks(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/booking/offer/' + params.bookingOfferId + '/banklinks', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInstantBookingSupportedBanklinks(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/booking/instant/request/' + params.bookingId + '/banklinks', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateBookingConsents(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/consents', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateInstantBookingConsents(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/instant/request/consents', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updatePrescription(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/prescription/request', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	saveBookingPrescription(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/prescription/request/weightloss', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	rescheduleBooking(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/booking/reschedule', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deleteMyAccount(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/user/delete/account', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitQuestionnaireAnswers(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/questionnaire/submit/' + params.questionnaireId + '/' + params.language + '', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitSummary(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/questionnaire/reviewed/evaluation/create', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

}
